import React, {useState} from 'react'

const IconButton = ({iconOn, iconOff, on, callback, title}) => {

    const [hover, setHover] = useState(false);

    const bStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '25px',
        color: 'rgb(27,35,54)',
        fontSize: '22px',
        background: on?'#86a451':'#A6A6A6',
        opacity: hover?0.7:1,
        borderRadius: '5px',
        border: '1px solid #727272',
        float: 'right',
        marginBottom: '6px',
        cursor: 'pointer',
    }


    return (
        <div
            style={bStyle}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={() => callback()}
            title={title}
        >
            {hover?on?iconOff:iconOn:on?iconOn:iconOff}
        </div>
    )
}

export default IconButton
